import { useMutation, useQueryClient } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { BrandPlan } from 'types'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

interface MutationData {
  brand_plan: BrandPlan
}

interface MutationVariables {
  content_strategy_type: string
  length?: number
  seo_contents?: Array<{ type: string; count: number; content_type?: string | null }>
  email_contents?: Array<{ type: string; count: number; content_type?: string | null }>
  instagram_contents?: Array<{ type: string; count: number; content_type?: string | null }>
  crosspost_contents?: Array<{ type: string; count: number; content_type?: string | null }>
  video_crosspost_contents?: Array<{ type: string; count: number; content_type?: string | null }>
  tactics?: string[]
}

export interface Props {
  brandPlanId: number
}

export const launchStrategy = async ({
  brandPlanId,
  workspaceId,
  ...variables
}: MutationVariables & { brandPlanId: number; workspaceId: number }) => {
  const res = await sendToApi<MutationData>(`/w/${workspaceId}/brand_plans/${brandPlanId}/launch_strategy`, {
    method: 'POST',
    body: variables,
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data.error)
  }

  return res.data
}

export const useLaunchStrategy = ({ brandPlanId }: Props) => {
  const workspaceId = useCurrentWorkspaceId()
  const queryClient = useQueryClient()

  return useMutation<MutationData, Error, MutationVariables>(async (variables) => {
    const data = await launchStrategy({
      workspaceId,
      brandPlanId,
      ...variables,
    })

    queryClient.invalidateQueries(['workspaces', workspaceId, 'brandPlans'])

    return data
  })
}
